module.exports = __webpack_public_path__ + "static/media/pa.d0787677.svg";